import api from "../config/apiConfig";
import {
  getSelectedActivity,
  getSelectedCompany,
  getSelectedPerson,
  getUserDetails,
  storeSelectedActivity,
  storeSelectedPerson,
} from "../utils/auth";
import { getAdminId, getRegisterId } from "../utils/authId";
import { toast } from "react-toastify";

export const ViewChannel = async (data) => {
  const id = getRegisterId();
  const user = getUserDetails();

  try {
    const response = await api.get(
      `api/get_channels/?register_id=${id}&other_user=${user.role}${data}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createChannel = async (formData) => {
  const id = getAdminId();
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...formData,
    allow_access: "all_people",
    managed_by: id,
    channel_manager: [regId],
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.post(`api/create_channel/`, data);
    toast.success("Channel Created successful!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};

//Fetch Channel By Id

export const FetchChannelIdApi = async (data) => {
  try {
    const response = await api.get(`api/selected_channel_details/${data}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const ChannelEdit = async (id, updates) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();

  const data = {
    ...updates,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(`api/channel_name_update/${id}/`, data);
    if (response) {
      toast.success("Updated Sucessfully", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
      const newChannelName =
        response?.data.channel_name_update[0]?.channel_name;
      const access = response?.data.channel_name_update[0]?.allow_access;
      const id = response?.data.channel_name_update[0]?.id;
      // Get and decrypt selected person
      const selectedPerson = getSelectedPerson(); // Should decrypt like getSelectedCompany()
      if (selectedPerson && selectedPerson.id === id) {
        const updatedPerson = {
          ...selectedPerson,
          channel_name: newChannelName,
          allow_access: access,
        };
        // Store back using encryption
        storeSelectedPerson(updatedPerson);
      }
      // Update only the channel name
      // Encrypt before saving
      const selectedActivity = getSelectedActivity();
      if (selectedActivity && selectedActivity.id === id) {
        const updatedActivity = {
          ...selectedActivity,
          name: newChannelName,
          allow_access: access,
        };
        storeSelectedActivity(updatedActivity);
      }
    }
  } catch (error) {
    throw error;
  }
};

//Channel Action

export const ChannelActionApi = async (id, Updates) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();

  const data = {
    ...Updates,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(
      `api/update_channel_manager_people/${id}/`,
      data
    );
    if (response) {
    }
  } catch (error) {
    throw error;
  }
};

// Channel Status Update

export const UpdateStatusChannelApi = async (formData) => {
  const regId = getRegisterId();
  const companyId = getSelectedCompany();
  const data = {
    ...formData,
    edited_company: companyId.id,
    edited_by_id: regId,
  };
  try {
    const response = await api.put(`api/channel_active_deactive/`, data);
    if (response) {
      toast.success("Update successful!", {
        position: "top-center",
        autoClose: 2000,
        closeButton: false,
        className: "custom_toast",
      });
    }
  } catch (error) {}
};
